(function () {
  function productSection(composer) {
    return composer.closest('[data-section-type="product-section"]') || composer.parentElement;
  }

  function buttonForm(composer) {
    return document.getElementById('product-form-buttons-' + composer.dataset.sectionId) || composer.closest('form');
  }

  function nativeSelector(composer) {
    var form = composer.closest('form');
    if (!form) return null;

    return form.querySelector(
      '.product__variants-swatches[data-section-id="' + composer.dataset.sectionId + '"], .product__variants-select[data-section-id="' + composer.dataset.sectionId + '"]'
    );
  }

  function selectNativeOption(composer, position, value) {
    var wrapper = nativeSelector(composer);
    if (!wrapper) return;

    var radio = Array.prototype.find.call(
      wrapper.querySelectorAll('input[type="radio"][data-position="' + position + '"]'),
      function (input) { return input.value === value; }
    );

    if (radio) {
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    var select = Array.prototype.find.call(
      wrapper.querySelectorAll('select.js-variant-selector'),
      function (item) { return item.querySelector('option[data-position="' + position + '"]'); }
    );

    if (select && select.value !== value) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function renderComposer(composer) {
    var pressed = composer.querySelector('[data-mm-offer-button][aria-pressed="true"]');
    var count = pressed ? Number(pressed.dataset.mmCount) : 1;
    var values = [];

    composer.querySelectorAll('[data-mm-slot-row]').forEach(function (row) {
      var active = Number(row.dataset.mmSlotRow) <= count;
      var select = row.querySelector('[data-mm-cushion-slot]');
      row.hidden = !active;
      select.disabled = !active;
      if (active) values.push(select.value);
    });

    var summary = composer.querySelector('[data-mm-cushion-summary]');
    if (summary) summary.textContent = 'Votre composition : ' + values.join(' · ');

    var total = composer.querySelector('[data-mm-cushion-total]');
    if (total && pressed) total.textContent = 'Total de l’offre : ' + pressed.dataset.mmOfferTotal;
  }

  function initializeComposer(composer) {
    var section = productSection(composer);
    var form = buttonForm(composer);
    var firstSlot = composer.querySelector('[data-mm-cushion-slot="1"]');

    if (section) {
      section.classList.add('mm-cushion-product');
      section.querySelectorAll('[data-product-qty]').forEach(function (quantity) {
        quantity.hidden = true;
      });
    }

    if (form) {
      form.classList.add('mm-cushion-product-form');
      var quantityInput = form.querySelector('[name="quantity"]');
      if (quantityInput) quantityInput.value = '1';
    }

    if (firstSlot) {
      selectNativeOption(composer, composer.dataset.offerPosition, composer.dataset.singleOfferValue);
      selectNativeOption(composer, composer.dataset.motifPosition, firstSlot.value);
    }

    renderComposer(composer);
  }

  function initializeComposers() {
    document.querySelectorAll('[data-mm-cushion-composer]').forEach(initializeComposer);
  }

  function composerForForm(form) {
    if (!form) return null;

    var direct = form.querySelector('[data-mm-cushion-composer]');
    if (direct) return direct;

    var prefix = 'product-form-buttons-';
    var formId = form.getAttribute('id') || '';
    if (formId.indexOf(prefix) === 0) {
      if (!form.classList.contains('product_form')) return null;
      return document.querySelector(
        '[data-mm-cushion-composer][data-section-id="' + formId.slice(prefix.length) + '"]'
      );
    }

    var section = form.closest('[data-section-type="product-section"]');
    return section ? section.querySelector('[data-mm-cushion-composer]') : null;
  }

  function selectedComposition(composer) {
    var pressed = composer.querySelector('[data-mm-offer-button][aria-pressed="true"]');
    var count = pressed ? Number(pressed.dataset.mmCount) : 1;
    var selections = [];

    composer.querySelectorAll('[data-mm-cushion-slot]').forEach(function (select) {
      if (Number(select.dataset.mmCushionSlot) > count) return;

      var option = select.selectedOptions[0];
      var id = option ? Number(option.dataset.mmVariantId) : 0;
      if (!id) throw new Error('Référence fournisseur introuvable pour ' + select.value);

      selections.push({
        id: id,
        motif: select.value,
        sku: option.dataset.mmSku || ''
      });
    });

    if (selections.length !== count) {
      throw new Error('La composition du lot est incomplète.');
    }

    return {
      count: count,
      label: pressed ? pressed.dataset.mmOfferValue : '1 coussin',
      selections: selections
    };
  }

  function cartItems(composition) {
    var grouped = {};
    var bundleId = 'MM-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
    var summary = composition.selections.map(function (item) { return item.motif; }).join(' + ');

    composition.selections.forEach(function (selection) {
      if (!grouped[selection.id]) {
        grouped[selection.id] = {
          id: selection.id,
          quantity: 0,
          properties: {
            '_Offre Maison Milaya': composition.label,
            '_Composition Maison Milaya': summary,
            '_Référence du lot': bundleId
          }
        };
      }
      grouped[selection.id].quantity += 1;
    });

    return Object.keys(grouped).map(function (id) { return grouped[id]; });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { cartItems: cartItems };
  }

  if (typeof document === 'undefined') return;

  function showError(form, message) {
    var error = form && form.querySelector('.js-error-msg');
    if (!error) {
      window.alert(message);
      return;
    }

    error.textContent = message;
    error.style.display = 'block';
  }

  function addComposition(composer, form, button) {
    if (composer.dataset.mmSubmitting === 'true') return;

    var composition;
    try {
      composition = selectedComposition(composer);
    } catch (error) {
      showError(form, error.message);
      return;
    }

    composer.dataset.mmSubmitting = 'true';
    if (button) {
      button.disabled = true;
      button.classList.add('disabled');
      button.dataset.mmOriginalText = button.textContent;
      button.textContent = 'Ajout en cours…';
    }

    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: cartItems(composition) })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || data.message || 'Impossible d’ajouter cette composition.');
          });
        }
        return response.json();
      })
      .then(function () {
        window.location.href = composer.dataset.cartUrl || '/cart';
      })
      .catch(function (error) {
        composer.dataset.mmSubmitting = 'false';
        if (button) {
          button.disabled = false;
          button.classList.remove('disabled');
          button.textContent = button.dataset.mmOriginalText || 'Ajouter au panier';
        }
        showError(form, error.message);
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mm-offer-button]');
    if (!button) return;

    var composer = button.closest('[data-mm-cushion-composer]');
    composer.querySelectorAll('[data-mm-offer-button]').forEach(function (item) {
      item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
    });

    /*
     * Keep Shopify's native variant on the real single-cushion SKU.
     * The bundle size is handled by the multi-item cart payload below.
     * Selecting a legacy P2/P3 option here would make the theme disable the
     * add-to-cart button because those safety variants are intentionally sold out.
     */
    selectNativeOption(composer, composer.dataset.offerPosition, composer.dataset.singleOfferValue);
    renderComposer(composer);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-mm-mobile-option-select]')) {
      var option = event.target.selectedOptions[0];
      var input = option && document.getElementById(option.dataset.targetId);
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    if (event.target.matches('[data-mm-cushion-slot]')) {
      var composer = event.target.closest('[data-mm-cushion-composer]');
      if (event.target.dataset.mmCushionSlot === '1') {
        selectNativeOption(composer, composer.dataset.motifPosition, event.target.value);
      }
      renderComposer(composer);
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.js-ajax-submit');
    if (!button) return;

    var form = button.closest('form');
    var composer = composerForForm(form);
    if (!composer) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addComposition(composer, form, button);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var composer = composerForForm(form);
    if (!composer) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addComposition(composer, form, form.querySelector('.js-ajax-submit'));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeComposers);
  } else {
    initializeComposers();
  }
})();

/* Maison Milaya — point 4 conversion mobile — 30-08-2026 */
(function () {
  var timers = [];
  var stickyObserver = null;
  var variantObserver = null;
  var observedAddButton = null;

  function candleWarmerSection() {
    return document.querySelector('[data-main-product][data-mm-candle-warmer="true"]');
  }

  function readProduct(section) {
    var script = section && section.querySelector('script.product-json');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function selectedOptions(section, optionCount) {
    var values = new Array(optionCount).fill(null);

    section
      .querySelectorAll('input[type="radio"][data-position]:checked')
      .forEach(function (input) {
        var index = Number(input.dataset.position) - 1;
        if (index >= 0 && index < optionCount) values[index] = input.value;
      });

    section.querySelectorAll('select').forEach(function (select) {
      var selected = select.options && select.options[select.selectedIndex];
      var position =
        Number(select.dataset.position) ||
        Number(selected && selected.dataset.position) ||
        Number(select.closest('[data-option-index]')?.dataset.optionIndex);
      var index = position - 1;
      if (index >= 0 && index < optionCount && select.value) {
        values[index] = select.value;
      }
    });

    return values;
  }

  function selectedVariant(section, product) {
    var variants = (product && product.variants) || [];
    if (!variants.length) return null;

    var optionCount = (variants[0].options || []).length;
    var values = selectedOptions(section, optionCount);
    var complete = values.length > 0 && values.every(Boolean);
    var match = complete
      ? variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === values[index];
          });
        })
      : null;
    if (match) return match;

    var urlId = new URLSearchParams(window.location.search).get('variant');
    match = variants.find(function (variant) {
      return String(variant.id) === String(urlId);
    });
    if (match) return match;

    var installmentId = section.querySelector(
      '.product-form-installment input[name="id"]'
    );
    match = variants.find(function (variant) {
      return String(variant.id) === String(installmentId && installmentId.value);
    });

    return match || variants.find(function (variant) { return variant.available; }) || variants[0];
  }

  function variantFields(section) {
    var fields = Array.from(section.querySelectorAll('.formVariantId'));
    var stickyField = document.querySelector('#sticky-cart .formVariantId');
    if (stickyField && fields.indexOf(stickyField) === -1) fields.push(stickyField);
    return fields;
  }

  function syncVariant() {
    var section = candleWarmerSection();
    if (!section) return;

    document.body.classList.add('mm-candle-warmer-product');
    var product = readProduct(section);
    var variant = selectedVariant(section, product);
    if (!variant) return;

    var fields = variantFields(section);
    fields.forEach(function (field) {
      var value = String(variant.id);
      field.setAttribute('name', 'id');
      field.setAttribute('value', value);
      if (field.value !== value) field.value = value;
    });

    var stickyButton = document.querySelector('#sticky-cart .sticky-add');
    if (stickyButton) stickyButton.disabled = !variant.available;
  }

  function nativeAddButton(section) {
    return Array.from(section.querySelectorAll('.js-ajax-submit')).find(function (button) {
      return !button.closest('#sticky-cart');
    });
  }

  function setStickyActive(active) {
    var sticky = document.querySelector('#sticky-cart');
    if (sticky) sticky.classList.toggle('mm-point4-active', active);
  }

  function updateStickyVisibility(button) {
    if (!button) {
      setStickyActive(true);
      return;
    }
    var rect = button.getBoundingClientRect();
    var unobscuredBottom = window.innerHeight - 132;
    var visibleHeight = Math.max(
      0,
      Math.min(rect.bottom, unobscuredBottom) - Math.max(rect.top, 0)
    );
    var ratio = rect.height > 0 ? visibleHeight / rect.height : 0;
    setStickyActive(ratio < 0.55);
  }

  function observeSticky(section) {
    var button = nativeAddButton(section);
    observedAddButton = button;
    if (stickyObserver) stickyObserver.disconnect();
    updateStickyVisibility(button);

    if (!button || !('IntersectionObserver' in window)) return;
    stickyObserver = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        setStickyActive(!(entry.isIntersecting && entry.intersectionRatio >= 0.55));
      },
      {
        root: null,
        rootMargin: '0px 0px -132px 0px',
        threshold: [0, 0.55, 1],
      }
    );
    stickyObserver.observe(button);
  }

  function refreshStickyOnScroll() {
    updateStickyVisibility(observedAddButton);
  }

  function observeVariantMarkup(section) {
    if (!('MutationObserver' in window)) return;
    if (variantObserver) variantObserver.disconnect();
    variantObserver = new MutationObserver(function (mutations) {
      var changed = mutations.some(function (mutation) {
        if (
          mutation.type === 'attributes' &&
          mutation.target.matches?.('.formVariantId') &&
          !mutation.target.value
        ) {
          return true;
        }
        return Array.from(mutation.addedNodes || []).some(function (node) {
          return (
            node.nodeType === 1 &&
            (node.matches?.('.formVariantId') || node.querySelector?.('.formVariantId'))
          );
        });
      });
      if (changed) scheduleSync();
    });
    variantObserver.observe(section, {
      attributes: true,
      attributeFilter: ['name', 'value'],
      childList: true,
      subtree: true,
    });
  }

  function scheduleSync() {
    timers.forEach(window.clearTimeout);
    timers = [0, 80, 240].map(function (delay) {
      return window.setTimeout(function () {
        syncVariant();
        if (delay === 240) {
          var section = candleWarmerSection();
          if (section) observeSticky(section);
        }
      }, delay);
    });
  }

  function init() {
    var section = candleWarmerSection();
    if (!section) return;
    document.body.classList.add('mm-candle-warmer-product');
    syncVariant();
    observeSticky(section);
    observeVariantMarkup(section);
    window.setTimeout(syncVariant, 400);
    window.setTimeout(syncVariant, 1200);
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('.formVariantId')) return;
    var section = candleWarmerSection();
    if (section && section.contains(event.target)) scheduleSync();
  });
  document.addEventListener(
    'pointerdown',
    function (event) {
      if (event.target?.closest('#sticky-cart .js-ajax-submit')) syncVariant();
    },
    true
  );
  document.addEventListener(
    'click',
    function (event) {
      if (event.target?.closest('#sticky-cart .js-ajax-submit')) syncVariant();
    },
    true
  );
  document.addEventListener(
    'submit',
    function (event) {
      var section = candleWarmerSection();
      if (section && section.contains(event.target)) syncVariant();
    },
    true
  );
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('scroll', refreshStickyOnScroll, true);
  window.addEventListener('popstate', scheduleSync);
  window.addEventListener('scroll', refreshStickyOnScroll, { passive: true });
  window.addEventListener('resize', refreshStickyOnScroll, { passive: true });
  window.addEventListener('load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
